
import _ from 'lodash';

export function getRepoInfo(repoUrl) {
    let user, repo, gitUserRepo, branch = '', path = '', commitSha = '';
    if (repoUrl) {
        let repoParts = repoUrl.split("/");

        if (repoParts.length > 2) {
            user = repoParts[3];
            repo = repoParts[4];

            if (repoParts[6]) {
                branch = repoParts[6];
                commitSha = repoParts[repoParts.length - 1];
                for (let i = 7; i < repoParts.length - 1; i++) {
                    path += repoParts[i] + '/';
                }
            }
            gitUserRepo = user + "/" + repo;
        }
    }
    return { user, repo, branch, path, gitUserRepo, commitSha };
}

export function getFilesAndFoldersByPath(files, folderPath, withGitEmpty) {
    const jsExt = '.js';
    const transformExt = '.transform.json';
    const testCaseExt = '.testcase';
    let resultFiles = [];

    if (!files) return null;

    if (folderPath === '') {
        resultFiles = files?.filter(file => file.path.indexOf('/') === -1);
    } else {
        resultFiles = files?.filter(file => {
            if (file.path.indexOf(folderPath) >= 0) {
                return file.path.replace(folderPath, '').split('/').length < 2;
            }
            return false;
        });
    }

    resultFiles = resultFiles?.filter(file => {
        if (file.type === 'blob') {
            if (withGitEmpty) {
                return file.path.toLowerCase().endsWith(jsExt) || file.path.toLowerCase().endsWith(transformExt) || file.path.toLowerCase().endsWith(testCaseExt) || file.path.toLowerCase().endsWith('.gitempty');
            }
            return file.path.toLowerCase().endsWith(jsExt) || file.path.toLowerCase().endsWith(transformExt) || file.path.toLowerCase().endsWith(testCaseExt);
        }
        return true;
    });

    resultFiles = _.sortBy(resultFiles, [
        (file) => file.type === 'blob',
        'path'
    ], ['asc', 'asc']);

    resultFiles = resultFiles.map(file => ({
        ...file,
        scriptType: file.path.toLowerCase().endsWith(transformExt) ? "transform" : "script",
        name: file.path.replace(folderPath, '').replace(transformExt, '').replace(jsExt, '').replace(testCaseExt, ''),
        nameToDisplay: file.path.replace(folderPath, '')
    }));

    return resultFiles;
}


export function getFilesByPath(files, folderPath, withGitEmpty) {
    return getFilesAndFoldersByPath(files, folderPath, withGitEmpty)
        .filter(file => file.type === 'blob');
}

export function buildFullRepoUrl({ repoUrl, branch, folder, commitSha }) {

    let fullUrl = `${repoUrl}`;
    let {
        branch: prevBranch, commitSha: prevCommitSha
    } = getRepoInfo(repoUrl);

    if (prevBranch && prevCommitSha) {
        return repoUrl.replace(prevCommitSha, commitSha).replace(prevBranch, branch);
    }

    if (branch && commitSha) {
        fullUrl += `/tree/${branch}/${folder}${commitSha}`;
    } else if (branch) {
        fullUrl += `/tree/${branch}/${folder}`;
    }

    return fullUrl;
}
